import * as React from 'react';
export const TvChannelComparisonContext = React.createContext({
    packagePrices: [],
    packageNames: [],
    channelInclusions: [],
    channelState: 'UNINITIALIZED',
    selectedPackage: null,
    setSelectedPackage: () => undefined,
    urlData: null
});
